<template>
    <div 
        class="spectrum-wheel-body" 
        ref="spectrumWheelBodyRef"
    > 

        <img
            v-show="isDesktop && !zoomEnabled"
            class="spectrum-wheel-desktop-select"
            src="../../../assets/images/SelectOptionDesktop.png"
            :style="{
                width: '40%',
                height: '40%',
                bottom: defaultProjectSpectrumArrowPosition.bottom,
                left: defaultProjectSpectrumArrowPosition.left,
                zIndex: 0
            }"
        />
            
        <img
            v-show="isMobile && !zoomEnabled"
            class="spectrum-wheel-mobile-select"
            src="../../../assets/images/SelectOptionMobile.png"
            :style="{
                width: '40%',
            }"
        />

        <div
            class="spectrum-wheel-skin"
            v-bind:style="{
                width: this.nativeWidth + 'px',
                height: this.computedSpectrumWheelHeight + 'px'
            }"
        >
            <img 
                v-if="zoomEnabled"
                class='spectrun-wheel-pimple'
                v-on:click.self="resetZoom()"
                :src="(isDesktop && selectedSegmentIndex === 4) ? require('../../../assets/images/spectrum-wheel/back-to-all-options-black.svg') : require('../../../assets/images/spectrum-wheel/back-to-all-options.svg')"  
                alt="back to all options button"
                v-bind:style="isDesktop 
                    ? {
                        width: '164px',
                        height: '80px',
                        top: backToAllOptionsDesktopPositioning[selectedSegmentIndex].top,
                        left: backToAllOptionsDesktopPositioning[selectedSegmentIndex].left,
                      } 
                    : {
                        top: '8%',
                        left: '50%',
                        transform: 'translate(-50%, 0)',
                        width: '40%'
                      }"
            />
            
            <div 
                class="spectrum-wheel-dermis"
                v-bind:style="{
                    width: this.nativeWidth + 'px',
                    height: this.nativeHeight + 'px',
                    top: isDesktop ? '-13%' : (dermisPositioning[selectedSegmentIndex] ? dermisPositioning[selectedSegmentIndex].positionTop + 'px' : '0px'),
                    left: isDesktop ? '0px' : (dermisPositioning[selectedSegmentIndex] ? dermisPositioning[selectedSegmentIndex].positionLeft + 'px' : '0px')
                }"

            >
                <div 
                    v-if="!zoomEnabled"
                    class="spectrum-wheel-guts"
                    v-bind:style="{
                        width: this.spectrumWheelGutsWidth + 'px',
                        height: this.spectrumWheelGutsHeight + 'px'
                    }"
                >   
                    

                    <WheelSeg 
                        :clickHandler="() => { setZoom(0) }"
                        :mouseleaveHandler="() => { resetZoom() }"
                        :matrix="segentPositioning[0].matrix"
                        :rotation="segentPositioning[0].rotation"
                        :positionTop="segentPositioning[0].positionTop"
                        :positionLeft="segentPositioning[0].positionLeft"
                        :defaultImage="require('../../../assets/images/spectrum-wheel/image-1.png')"
                        :hoverImage="require('../../../assets/images/spectrum-wheel/image-1.png')" 
                        :isMobileView="isMobile && zoomEnabled"
                        :wheelSegmentIndex="0"
                        :initialDefaultHoveredValues="initialDefaultHover"
                        @resetDefaultHoverValues="resetInitialDefaultHover"
                    /> 
                    
                    <WheelSeg 
                        :clickHandler="() => { setZoom(1) }"
                        :mouseleaveHandler="() => { resetZoom() }"
                        :matrix="segentPositioning[1].matrix"
                        :rotation="segentPositioning[1].rotation"
                        :positionTop="segentPositioning[1].positionTop"
                        :positionLeft="segentPositioning[1].positionLeft"
                        :defaultImage="require('../../../assets/images/spectrum-wheel/image-2.png')"
                        :hoverImage="require('../../../assets/images/spectrum-wheel/image-2.png')" 
                        :isMobileView="isMobile && zoomEnabled"
                        :wheelSegmentIndex="1"
                        :initialDefaultHoveredValues="initialDefaultHover"
                        @resetDefaultHoverValues="resetInitialDefaultHover"
                    /> 

                    <WheelSeg 
                        :clickHandler="() => { setZoom(2) }"
                        :mouseleaveHandler="() => { resetZoom() }"
                        :matrix="segentPositioning[2].matrix"
                        :rotation="segentPositioning[2].rotation"
                        :positionTop="segentPositioning[2].positionTop"
                        :positionLeft="segentPositioning[2].positionLeft"
                        :defaultImage="require('../../../assets/images/spectrum-wheel/image-3.png')"
                        :hoverImage="require('../../../assets/images/spectrum-wheel/image-3.png')" 
                        :isMobileView="isMobile && zoomEnabled"
                        :wheelSegmentIndex="2"
                        :initialDefaultHoveredValues="initialDefaultHover"
                        @resetDefaultHoverValues="resetInitialDefaultHover"
                    /> 

                    <WheelSeg 
                        :clickHandler="() => { setZoom(3) }"
                        :mouseleaveHandler="() => { resetZoom() }"
                        :matrix="segentPositioning[3].matrix"
                        :rotation="segentPositioning[3].rotation"
                        :positionTop="segentPositioning[3].positionTop"
                        :positionLeft="segentPositioning[3].positionLeft"
                        :defaultImage="require('../../../assets/images/spectrum-wheel/image-4.png')"
                        :hoverImage="require('../../../assets/images/spectrum-wheel/image-4.png')" 
                        :isMobileView="isMobile && zoomEnabled"
                        :wheelSegmentIndex="3"
                        :initialDefaultHoveredValues="initialDefaultHover"
                        @resetDefaultHoverValues="resetInitialDefaultHover"
                    /> 

                    <WheelSeg 
                        :clickHandler="() => { setZoom(4) }"
                        :mouseleaveHandler="() => { resetZoom() }"
                        :matrix="segentPositioning[4].matrix"
                        :rotation="segentPositioning[4].rotation"
                        :positionTop="segentPositioning[4].positionTop"
                        :positionRight="segentPositioning[4].positionRight"
                        :defaultImage="require('../../../assets/images/spectrum-wheel/image-5.png')"
                        :hoverImage="require('../../../assets/images/spectrum-wheel/image-5.png')" 
                        :isMobileView="isMobile && zoomEnabled"
                        :wheelSegmentIndex="4"
                        :initialDefaultHoveredValues="initialDefaultHover"
                        @resetDefaultHoverValues="resetInitialDefaultHover"
                    /> 

                    <WheelSeg 
                        :clickHandler="() => { setZoom(5) }"
                        :mouseleaveHandler="() => { resetZoom() }"
                        :matrix="segentPositioning[5].matrix"
                        :rotation="segentPositioning[5].rotation"
                        :positionTop="segentPositioning[5].positionTop"
                        :positionRight="segentPositioning[5].positionRight"
                        :defaultImage="require('../../../assets/images/spectrum-wheel/image-6.png')"
                        :hoverImage="require('../../../assets/images/spectrum-wheel/image-6.png')" 
                        :isMobileView="isMobile && zoomEnabled"
                        :wheelSegmentIndex="5"
                        :initialDefaultHoveredValues="initialDefaultHover"
                        @resetDefaultHoverValues="resetInitialDefaultHover"
                    /> 

                    <WheelSeg 
                        :clickHandler="() => { setZoom(6) }"
                        :mouseleaveHandler="() => { resetZoom() }"
                        :matrix="segentPositioning[6].matrix"
                        :rotation="segentPositioning[6].rotation"
                        :positionTop="segentPositioning[6].positionTop"
                        :positionRight="segentPositioning[6].positionRight"
                        :defaultImage="require('../../../assets/images/spectrum-wheel/image-7.png')"
                        :hoverImage="require('../../../assets/images/spectrum-wheel/image-7.png')" 
                        :isMobileView="isMobile && zoomEnabled"
                        :wheelSegmentIndex="6"
                        :initialDefaultHoveredValues="initialDefaultHover"
                        @resetDefaultHoverValues="resetInitialDefaultHover"
                    /> 

                    <img 
                        v-if="!zoomEnabled"
                        class="ps-logo" 
                        alt="project spectrum logo" 
                        src="../../../assets/images/spectrum-wheel/ps-logo.png" 
                        v-bind:style="{
                            position: 'absolute',
                            zIndex: 1,
                            width: psLogoPositioning.width + 'px',
                            left: psLogoPositioning.positionLeft + 'px',
                            top: psLogoPositioning.positionTop + 'px'
                        }"
                    />

                </div>
            </div>   

            <div v-show="!isMobile && zoomEnabled" style="width: 100%; height: 100%; position: absolute;">
                <img alt="wheel segment image" class="img-fluid w-100 h-100" :src="wheelSegmentDesktopBackgroundImages[selectedSegmentIndex]" />
            </div>

            <!---------------- MOBILE WHEEL-SEGMENT DISPLAYED ONLY ZOOM IS ENABLED -------------------->
            <div v-show="isMobile && zoomEnabled" style="width: 100%; height: 100%; position: relative;">
                <div
                    style="position:absolute; width: 100px; height: auto; font-size: 18px; font-weight: 700; text-align: center; font-family: Rajdhani;"
                    :style="{
                        top: '50%',
                        left: '50%',
                        transform: selectedSegmentIndex === 2 || selectedSegmentIndex === 5 ? 'translate(-50%, -15%)' : 'translate(-50%, 50%)',
                        color: wheelSegmentTitles[selectedSegmentIndex]?.color,
                    }"
                >
                    {{ wheelSegmentTitles[selectedSegmentIndex]?.title }}
                </div>
                <img 
                    :src="wheelSegmentMobileImages[selectedSegmentIndex]" 
                    style="width: 100%; height: 100%; object-fit: cover;"
                    alt="image caption"
                >
            </div>
        </div>
    </div>
</template>

<script>
import WheelSeg from './wheel-seg.vue';
import { EventBus } from "../../../utils/eventBus";

export default {
    name: "SpectrumWheel",
    components: {
        WheelSeg
    },
    props: {
        selectedSegmentName: String,
    },
    data: function() {
        return {
            zoomEnabled: false,
            zoomFactor: 1.7,
            nativeHeight: 0,
            nativeWidth: 0,
            selectedSegmentIndex: 7,
            selectedSegment: null,
            segmentNames: [
                'Cybersecurity',
                'ProjectSpectrum',
                'SpectrumManufacturers',
                'UnderstandingData',
                'BusinessTools',
                'CMMC',
                'NIST800-171',
            ],
            routeToSegmentMap: {
                'Cybersecurity': 0,
                'ProjectSpectrum': 1,
                'SpectrumManufacturers': 2,
                'UnderstandingData': 3,
                'BusinessTools': 4,
                'CMMC': 5,
                'NIST800-171': 6
            },
            wheelSegmentMobileImages: [
                require('../../../assets/images/spectrum-wheel/mobile-spectrum-Cybersecurity.png'),
                require('../../../assets/images/spectrum-wheel/mobile-spectrum-ProjectSpectrum2.png'),
                require('../../../assets/images/spectrum-wheel/mobile-spectrum-Manufactruers.png'),
                require('../../../assets/images/spectrum-wheel/mobile-spectrum-UnderstandingData.png'),
                require('../../../assets/images/spectrum-wheel/mobile-spectrum-BusinessTools.png'),
                require('../../../assets/images/spectrum-wheel/mobile-spectrum-CMMC.png'),
                require('../../../assets/images/spectrum-wheel/mobile-spectrum-NIST.png'),
            ],
            wheelSegmentDesktopBackgroundImages: [
                require('../../../assets/images/spectrum-wheel/zoomed-Cybersecurity-withwords.png'),
                require('../../../assets/images/spectrum-wheel/zoomed-PS-withwords.png'),
                require('../../../assets/images/spectrum-wheel/zoomed-Manufacturers-withwords.png'),
                require('../../../assets/images/spectrum-wheel/zoomed-Data-withwords.png'),
                require('../../../assets/images/spectrum-wheel/zoomed-BusinessTools-withwords.png'),
                require('../../../assets/images/spectrum-wheel/zoomed-WhatIsCMMC-withwords.png'),
                require('../../../assets/images/spectrum-wheel/zoomed-NIST-withwords.png'),
                
            ],
            wheelSegmentTitles: [
                {
                    title: 'Cybersecurity', 
                    color: '#000',
                },
                {
                    title: '', 
                    color: '#fff',
                },
                {
                    title: 'Spectrum for Manufacturers', 
                    color: '#fff',
                },
                {
                    title: 'Understanding My Data', 
                    color: '#fff',
                },
                {
                    title: 'Tools for My Business', 
                    color: '#000',
                },
                {
                    title: 'What Is CMMC?', 
                    color: '#fff',
                },
                {
                    title: '', 
                    color: '#fff',
                },
            ],
            backToAllOptionsDesktopPositioning: [
                {
                    top: '22%',
                    left: '7%',
                },
                {
                    top: '13%',
                    left: '6%',
                },
                {
                    top: '21%',
                    left: '10%',
                },
                {
                    top: '11%',
                    left: '8%',
                },
                {
                    top: '10%',
                    left: '17%',
                },
                {
                    top: '9%',
                    left: '23%',
                },
                {
                    top: '18%',
                    left: '29%',
                },
            ],
            initialDefaultHover: [
                false,
                true,
                false,
                false,
                false,
                false,
                false,
            ],
            defaultProjectSpectrumArrowPosition: {
                left: '4%',
                bottom: '7%',
            },
        }
    },
    computed: {
        calcualtedMatrix() {
            let baseMatrix = this.nativeWidth - (this.nativeWidth * .73);
            if(this.zoomEnabled) {
                return baseMatrix + (baseMatrix * this.zoomFactor);
            } else {
                return baseMatrix
            }
        },
        spectrumWheelGutsWidth() {
            if(this.zoomEnabled) {
                return this.nativeWidth + (this.nativeWidth * this.zoomFactor);
            } else {
                return this.nativeWidth;
            }
        },
        spectrumWheelGutsHeight() {
            if(this.zoomEnabled) {
                return this.nativeHeight + (this.nativeHeight * this.zoomFactor);
            } else {
                return this.nativeHeight;
            }
        },
        segentPositioning() {

            return [
                {
                    matrix: this.calcualtedMatrix,
                    rotation: 90,
                    positionTop: 0,
                    positionLeft: 0,
                    mobilePositionLeft: '0%',
                    mobilePositionBottom: '60%',
                },
                {
                    matrix: this.calcualtedMatrix,
                    rotation: 60,
                    positionTop: this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * .72),
                    positionLeft: this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * .95),
                    mobilePositionLeft: '4%',
                    mobilePositionBottom: '28%',
                },
                {
                    matrix: this.calcualtedMatrix,
                    rotation: 30,
                    positionTop: this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * .515),
                    positionLeft: this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * .815),
                    mobilePositionLeft: '15%',
                    mobilePositionBottom: '7%',
                },
                {
                    matrix: this.calcualtedMatrix,
                    rotation: 0,
                    positionTop: this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * .44),
                    positionLeft: (this.spectrumWheelGutsWidth / 2) - (this.calcualtedMatrix / 2),
                    mobilePositionLeft: '35%',
                    mobilePositionBottom: '6%',
                },
                {
                    matrix: this.calcualtedMatrix,
                    rotation: -30,
                    positionTop: this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * .515),
                    positionRight: this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * .815),
                    mobilePositionLeft: '55%',
                    mobilePositionBottom: '13%',
                },
                {
                    matrix: this.calcualtedMatrix,
                    rotation: -60,
                    positionTop: this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * .72),
                    positionRight: this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * .95),
                    mobilePositionLeft: '70%',
                    mobilePositionBottom: '29%',
                },
                {
                    matrix: this.calcualtedMatrix,
                    rotation: -90,
                    positionTop: 0,
                    positionRight: 0,
                    mobilePositionLeft: '80%',
                    mobilePositionBottom: '57%',
                },
            ]
        },
        dermisPositioning() {

            return [
                {
                    positionTop: this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * 1.03),
                    positionLeft: this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * .95)
                },
                {
                    positionTop: this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * 1.325),
                    positionLeft: this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * 1.00)
                },
                {
                    positionTop: this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * 1.54),
                    positionLeft: this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * 1.1)
                },
                {
                    positionTop: this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * 1.60),
                    positionLeft: this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * 1.3)
                },
                {
                    positionTop: this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * 1.52),
                    positionLeft: this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * 1.50)
                },
                {
                    positionTop: this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * 1.32),
                    positionLeft: this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * 1.65)
                },
                {
                    positionTop: this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * 1.04),
                    positionLeft: this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * 1.75)
                },
                // default position below
                {
                    positionTop: this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * 1.0),
                    positionLeft: this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * 1)
                },
            ]

        },
        pimplePositioning() {

            const pimpleWidth = this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * .85);
            const pimplePositionLeft = this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth  * .98);
            const pimplePositionTop = this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * .98)

            return({
                width: pimpleWidth,
                top:  pimplePositionLeft,
                left: pimplePositionTop
            })
        },
        psLogoPositioning() {

            const logoWidth = this.spectrumWheelGutsWidth - (this.spectrumWheelGutsWidth * .7);
            const logoWidthZoomed = logoWidth + (logoWidth * this.zoomEnabled);
            const positionLeft = this.spectrumWheelGutsWidth - ( (this.spectrumWheelGutsWidth  / 2) + logoWidth / 2 );
            const positionLeftZoomed = positionLeft + (positionLeft * this.zoomFactor);
            const positionTop = this.spectrumWheelGutsHeight - (this.spectrumWheelGutsHeight * .78)
            
            if ( this.zoomEnabled ) {
                return({
                    width: logoWidthZoomed,
                    positionLeft: positionLeftZoomed,
                    positionTop: positionTop
                })
            } else {
                return({
                    width: logoWidth,
                    positionLeft: positionLeft,
                    positionTop: positionTop
                })
            }
           
        },
        isDesktop() {
            return this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl || this.$vuetify.breakpoint.md;
        },
        isMobile() {
            return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs;
        },
        computedSpectrumWheelHeight() {
            return (this.isMobile && this.zoomEnabled) ? this.$refs.spectrumWheelBodyRef.offsetWidth - (this.$refs.spectrumWheelBodyRef.offsetWidth * .18) : this.nativeHeight;
        },
    },
    methods: {
        // Handles window resize events to maintain proper wheel dimensions
        resizeEvenHandler(e) {
            this.nativeWidth = this.$refs.spectrumWheelBodyRef.offsetWidth;
            this.nativeHeight = this.$refs.spectrumWheelBodyRef.offsetWidth - (this.$refs.spectrumWheelBodyRef.offsetWidth * .36);
        },

        // Handles zoom functionality and route updates when a segment is selected
        setZoom(segmentIndex) {
            this.zoomEnabled = segmentIndex !== null;
            this.selectedSegmentIndex = segmentIndex;
            this.selectedSegment = this.segmentNames[segmentIndex];
            this.$emit("receive-selected-segment", this.selectedSegment);
        },

        // Resets the wheel to its default state
        resetZoom() {
            this.$emit("back-button-clicked");
            this.zoomEnabled = false;
            this.selectedSegmentIndex = 0;
            this.initialDefaultHover[1] = true;
            this.selectedSegment = null;
            this.$emit("receive-selected-segment", this.selectedSegment);
            
            // Force scroll to top of page
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
            
        // Handles hover state changes for wheel segments
        resetInitialDefaultHover({ defaultIndex, isEnlarged }) {
            this.initialDefaultHover[defaultIndex] = isEnlarged;
            this.initialDefaultHover = [ ...this.initialDefaultHover ];
            this.defaultProjectSpectrumArrowPosition = isEnlarged 
                                                        ? { ...this.defaultProjectSpectrumArrowPosition, bottom: '7%' } 
                                                        : { ...this.defaultProjectSpectrumArrowPosition, bottom: '12%' };
        },

    },
    created() {
        EventBus.$on("restore-back-to-wheel", this.resetZoom);
        window.addEventListener("resize", this.resizeEvenHandler);
    },
    destroyed() {
        EventBus.$off("restore-back-to-wheel", this.resetZoom);
        window.removeEventListener("resize", this.resizeEvenHandler);
    },
    mounted() {
        this.resizeEvenHandler();
    },
    watch: {
        selectedSegmentName(newValue) {
            if (!newValue) {
                this.setZoom(null);
                return;
            }

            const segmentIndex = this.segmentNames.indexOf(newValue);
            if (segmentIndex !== -1) {
                this.setZoom(segmentIndex);
            }
        },

        $route: {
            handler(to) {
                if (to.query.segment && this.routeToSegmentMap[to.query.segment] !== undefined) {
                    this.setZoom(this.routeToSegmentMap[to.query.segment]);
                }
            },
            immediate: true
        },
    }
}
</script>

<style>
.spectrum-wheel-body {
    position: relative;
}
.spectrum-wheel-skin {
    position: relative;
    overflow: hidden;
}

.spectrum-wheel-dermis {
    position: absolute;
}

.spectrum-wheel-guts {
    position: relative;    
}

.spectrun-wheel-pimple {
    position: absolute;
    z-index: 900;
    cursor: pointer;
}

.spectrum-wheel-desktop-select {
    position: absolute;
    z-index: 900;
}

.spectrum-wheel-mobile-select {
    position: absolute;
    top: 10px;
    right: 50%;
    transform: translateX(50%);
    margin-left: auto;
    margin-right: auto;
    z-index: 900;
}

.spectrun-wheel-pimple:hover {
    opacity: .66;
}

.spectrun-wheel-pimple:active {
    opacity: .33;
}


</style>